import util from '@bmp-vue/core/api/util'

const controller = 'ArranjoPagamentos'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'persist']), {})
